import { action, makeObservable, observable } from 'mobx';

class SideBetsInfoStore {
  sideBetsInfo = null;

  sideBetsMultiplayer = null;

  constructor() {
    makeObservable(this, {
      sideBetsInfo: observable.deep,
      sideBetsMultiplayer: observable.deep,
      setSideBetsInfo: action.bound,
      setSideBetsMultiplayer: action.bound,
    });
  }

  setSideBetsInfo(data) {
    this.sideBetsInfo = data;
  }

  setSideBetsMultiplayer(data) {
    this.sideBetsMultiplayer = data;
  }
}

export const sideBetsInfoStore = new SideBetsInfoStore();
